import React, { useEffect, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { EE, HelperCore } from '@/common/dependencies';
import { SVGPureIcon } from '@/ui';
import { getMcpToolsConfig, McpToolsConfig } from '@shared/constants/mcp';
import connectionLineStore from '@/components/chat-history/connection-line/store';
import CircleLoading from '@/components/ani/circle-loading';
import { uniq } from 'lodash-es';
import ProcessBar from '@/components/process-bar';
import FlowIcon from '@/components/flow-icon';

const McpToolsParams = observer((props) => {
  const {
    className = '',
    event,
    mcpStore,
    messageItem,
    isAITyping,
    hideTitle,
  } = props;

  const hasDone = event.status == "success" || event.type == "queryList";
  const paramsText = mcpStore.getNodeParamsText(event);
  // const [folded, setFolded] = useState(true);
  const [folded, setFolded] = useState(event.tool != "knowledge_analyse");
  const toggleFolded = (event) => {
    event.stopPropagation();
    if(!paramsText && props?.event?.type != "queryList"){
      return;
    }

    // setFolded(_ => !_);
  }

  const config = getMcpToolsConfig(event);
  if(config.hidden){
    return null;
  }

  const toolConfig = mcpStore.getFixedToolText(event);
  let disabled = false;
  try{
    disabled = toolConfig.disabled;
  } catch(e){}

  useEffect(() => {
    if(event.type == 'queryList') {
      setFolded(false)
    }
  }, [])

  const children = event.children || [];

  const id = `${messageItem?.msg_id || ''}_${event?.planStepId || ''}`;

  // debug
  // if(event.type == "toolNeedConfirm"){
  //   HelperCore.log(`任务规划状态`, {
  //     hasDone,
  //     isAITyping,
  //     messageItem,
  //     toolConfig,
  //   });
  // }

  const renderChildren = () => {
    return children.map((item, index) => {
      return (
        <McpToolsParams 
          key={`leve4_${event.planStepId}_${index}`}
          className=""
          event={{
            ...item,
          }}
          mcpStore={mcpStore}
          messageItem={messageItem}
          hideTitle={hideTitle}
          />
      )
    })
  }

  return (
    <>
    <div className="tools-params flex flex-col relative overflow-hidden rounded-6px">
      <div 
        className={[
          'js-mcptools mcptools px-10px w-full flex flex-col border-black border-opacity-10 border-1px rounded-6px',
          `${(config && config.key != "default" && !disabled) || ["queryList", "toolNeedConfirm","extraData"].includes(event?.type) ? "cursor-pointer hover:bg-black hover:bg-opacity-3" : ""}`,
          `${className}`]}
        data-id={id}
        // data-json={JSON.stringify(event)}
        data-tool={event?.tool}
        data-idx={event?.idx}
        onClick={
          (e) => {
            e.stopPropagation();
            if(!mcpStore){
              return;
            }
            if(disabled){
              return;
            }
            // if(!McpToolsConfig[event.tool] && event?.type != "queryList"){
            //   toggleFolded(e);
            //   return;
            // }
            if(!config || config.key == "default"){
              toggleFolded(e);
              return;
            }
            if(messageItem){
              mcpStore.setPanelMessageId(messageItem.msg_id);
            }
            if(mcpStore.currentPanelId == event.planStepId && mcpStore.showRightPanel){
              EE.emit("vnc-cards-scroll");
            }
            else {
              mcpStore.setCurrentPanelId(event.planStepId, true);
              EE.emit("vnc-cards-scroll");
            }
            connectionLineStore.updatePoint(id);
          }
        }
        >
        <div className="flex w-full h-32px items-center">
          {
            mcpStore.isAgentFlow && !["planStatus", "planThink"].includes(event.type)
            ? <FlowIcon event={event} className='size-18px mr-3px rounded-4px flex-shrink-0' />
            : <SVGPureIcon name={`${config.getIcon ? config.getIcon(event) : config.icon}`} className='size-18px mr-3px flex-shrink-0' />
          }
          {
            [
              "agentBlock",
              "agentInteraction",
            ].includes(event.type)
            ? (
              <div className="mcptools-text text-13px text-black text-opacity-80 leading-18px flex items-center flex-shrink max-w-8/10">
                <div className="mcp-mobile-hidden flex-shrink-0">运行节点：</div>
                <div className="font-bold text-black text-opacity-80 flex-shrink truncate">{mcpStore.getFixedToolText(event, true)}</div>
              </div>
            )
            : [
              "toolStatus",
            ].includes(event.type)
            ? (
              <div className="mcptools-text text-13px text-black text-opacity-80 leading-18px flex items-center flex-shrink max-w-8/10">
                <div className="mcp-mobile-hidden flex-shrink-0">
                  {mcpStore.isAgentFlow && event.agent_name ? `${event.agent_name}：` : '调用技能（MCP工具）：'}
                </div>
                {
                  event.serverName
                  ? (
                    <>
                      <div className="font-bold flex-shrink truncate ml-6px text-black text-opacity-80">{event.serverNameCN || event.serverName}</div>
                      <div className="h-1px w-6px bg-black bg-opacity-80 mx-6px"></div>
                    </>
                  )
                  : null
                }
                <div className="font-bold text-black text-opacity-80 flex-shrink truncate">{event.toolCN || event.tool}</div>
              </div>
            )
            : [
              "knowledgeStatus",
            ].includes(event.type)
            ? (
              <div className="mcptools-text text-13px text-black text-opacity-80 leading-18px flex items-center flex-shrink max-w-8/10">
                <div className={`text-black flex-shrink truncate ${ hideTitle ? '' : 'text-opacity-50'}`}>
                  {
                    /^解析文档\:/.test(event.title || "")
                    ? (
                      <>
                        解析文档:
                        <font className="font-bold">{event.title.replace(/^解析文档\:/, '')}</font>
                      </>
                    )
                    : event.title
                  }
                </div>
              </div>
            )
            : (
              <div 
                className="mcptools-text text-13px text-black text-opacity-80 leading-18px flex items-center flex-shrink max-w-8/10 line-clamp-1"
                title={mcpStore.getFixedToolText(event, true)}
              >
                {mcpStore.getFixedToolText(event, true)}
              </div>
            )
          }
          {/* loading/done */}
          {
            toolConfig?.eventStatus == "failed"
            ? <SVGPureIcon name={`mcp_error`} className='size-16px ml-6px text-[#FF3B30] flex-shrink-0' />
            : !hasDone
            ? (
              isAITyping
              ? null
              // ? <CircleLoading className="!size-16px ml-6px flex-shrink-0" />
              : null
            )
            : <SVGPureIcon name={`done`} className='size-16px ml-6px text-[#33C481] flex-shrink-0' />
          }
          <div className="w-0 flex-grow"></div>
          {
            toolConfig?.eventStatus == "running" && toolConfig.runningText 
            ? (
              <div className="text-13px">{toolConfig.runningText}</div>
            )
            : null
          }
        </div>
        {
          !folded && !children.length && event.type != "queryList"
          ? (
            <div 
              className="pt-3px pb-10px"
              onClick={
                (event) => {
                  event.stopPropagation();
                }
              }>
              <div className="bg-white rounded-12px p-12px whitespace-pre-wrap text-13px text-black cursor-default leading-22px break-all">
                { paramsText }
              </div>
            </div>
          )
          : null
        }
        {
          !folded && event.type == "queryList"
          ? (
            <div 
              className="pt-3px pb-10px"
              onClick={
                (event) => {
                  event.stopPropagation();
                }
              }>
              <div className="bg-white rounded-12px p-12px pb-4px whitespace-pre-wrap text-13px text-black cursor-default leading-22px break-all">
                {
                  uniq(event.text.split("|") || []).map((keyWord, index) => {
                    return (
                      <div
                        key={index}
                        className='flex gap-8px mb-8px h-18px items-center'
                      >
                        <SVGPureIcon 
                          name="mcp-search"
                          size={16}
                        />
                        <div className='text-13px text-black w-0 flex-grow line-clamp-1' title={keyWord}>
                          {keyWord}
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          )
          : null
        }
      </div>

      {
        !folded && children.length && !hideTitle
        ? (
          <div className="mt-8px flex flex-col gap-8px pl-24px">
            { renderChildren() }
          </div>
        )
        : null
      }
      {/* loading */}
      {
        toolConfig.eventStatus == "failed" || !toolConfig.eventStatus
        ? null
        : !hasDone
        ? (
          mcpStore && isAITyping && event.type != "planUpdate"
          ? <ProcessBar className="absolute bottom-1px" />
          : null
        )
        : null
      }
    </div>
    {
      !folded && children.length && hideTitle
      ? (
        <div className="mt-8px flex flex-col gap-8px">
          { renderChildren() }
        </div>
      )
      : null
    }
    </>
  )
});
export default McpToolsParams;